import React from 'react';
import { Link } from 'react-router-dom';

const LEAD_FORM = 'https://api.leadconnectorhq.com/widget/form/xSNa1tu0CCXyei8UJ2ew';

// Closing CTA + page-content copyright bar. The site-standard <Footer /> still
// renders below this component.
const FooterSection = () => (
  <>
    <section className="vipo-section vipo-footer-cta">
      <div className="vipo-container vipo-container--cta">
        <p className="vipo-section__label">Ready to Get Started?</p>
        <h2 className="vipo-section__heading vipo-footer-cta__heading">
          Ready to see how Rentid fits your rental business?
        </h2>
        <p className="vipo-section__intro vipo-footer-cta__intro">
          Schedule your VIP onboarding and we'll walk you through the tools, workflows,
          and protection options available for your operation.
        </p>

        <div className="vipo-cta-row">
          <Link
            to="https://app.rentid.io/sign-up"
            className="vipo-btn vipo-btn--primary"
          >
            Get started
          </Link>
          <a
            href={LEAD_FORM}
            target="_blank"
            rel="noopener noreferrer"
            className="vipo-btn vipo-btn--secondary"
          >
            Book Demo
          </a>
        </div>
      </div>
    </section>
  </>
);

export default FooterSection;
